import { render, staticRenderFns } from "./Bookmark.vue?vue&type=template&id=79e18b24&lang=pug"
import script from "./Bookmark.vue?vue&type=script&lang=ts"
export * from "./Bookmark.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports